import React, { useEffect, useState, type Dispatch, type SetStateAction } from 'react'
import CloseIconBasic from '../../elements/CloseIconBasic'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { setScheduleFilters, setShowPopupScheduleFilters } from '../../../../store/slices/modalSlice'
import { type RootState } from '../../../../store/store'
import { REACT_APP_BSO_USER_ID } from '../../../../urls'
import ScheduleAdminUnitsList from './ScheduleAdminUnitsList'
import { NotFill } from './NotFill'
import { DEFAULT_SCHEDULE_FILTERS, type ScheduleFiltersState } from './scheduleFilters.types'
import { STATUS_PHASES, VIEWING_PHASES, ADS_PHASES } from './useScheduleFiltersVM'
import TopmostFooterPortal from './TopmostFooterPortal'

interface IProps {
    scheduleFiltersApply: boolean
    setScheduleFiltersApply: Dispatch<SetStateAction<boolean>>
    filteredViewings: any
    filteredOffers: any
    filteredAdvertises: any
}

export default function ScheduleFiltersList({
    scheduleFiltersApply,
    setScheduleFiltersApply,
    filteredViewings,
    filteredOffers,
    filteredAdvertises
}: IProps): JSX.Element {
    const dispatch = useAppDispatch()
    const userDevice = useAppSelector((state) => state.app.userDevice)
    const scheduleFilters = useAppSelector((state: RootState) => state.modal.scheduleFilters) as ScheduleFiltersState
    const loading = useAppSelector((state) => state.modal.loading)
    const [localFilters, setLocalFilters] = useState<ScheduleFiltersState>(scheduleFilters)
    const filterNavigate = useAppSelector((state: RootState) => state.schedule.filterNavigate)

    const units = useAppSelector((state: RootState) => state.units.units)?.filter(
        (unit) =>
            unit.attributes?.User?.data?.id &&
            unit.attributes?.User?.data?.id === Number(process.env.REACT_APP_BSO_USER_ID ?? REACT_APP_BSO_USER_ID ?? '57') &&
            unit.attributes?.ManagedBy === 'BSO' &&
            Boolean(unit?.attributes?.Marketing)
    )

    let listUnits = units
    if (filterNavigate === 'offers') {
        listUnits = units?.filter((unit) => unit.attributes?.Offers?.data && unit.attributes?.Offers?.data?.length > 0)
    }
    if (filterNavigate === 'viewings') {
        listUnits = units?.filter((unit) => unit.attributes?.Viewings?.data && unit.attributes?.Viewings?.data?.length > 0)
    }
    if (filterNavigate === 'adverts') {
        listUnits = units?.filter((unit) => unit.attributes?.Advertises?.data && unit.attributes?.Advertises?.data?.length > 0)
    }

    useEffect(() => {
        setLocalFilters(scheduleFilters)
    }, [scheduleFilters])

    const applyFilters = () => {
        dispatch(setScheduleFilters(localFilters))
        dispatch(setShowPopupScheduleFilters(false))
        if (!scheduleFiltersApply) {
            setScheduleFiltersApply(true)
        }
    }

    const resetFilters = () => {
        setLocalFilters(DEFAULT_SCHEDULE_FILTERS)
        dispatch(setScheduleFilters(DEFAULT_SCHEDULE_FILTERS))
        dispatch(setShowPopupScheduleFilters(false))
        if (!scheduleFiltersApply) {
            setScheduleFiltersApply(true)
        }
    }

    return (
        <div className="page  fs-5 w-100 mx-auto">
            <div className="content w-100 mw-450px mx-auto ">
                <div
                    className="bg-white position-sticky top-0 "
                    style={{
                        paddingTop: userDevice === 'IPhone' ? '45px' : '14px',
                        paddingBottom: '14px',
                        zIndex: '9999'
                    }}
                >
                    <div className="h-100  w-100vw">
                        <h3 className="text-uppercase  p-4 ">Schedule Filters</h3>

                        {
                            <CloseIconBasic
                                onCancel={() => {
                                    dispatch(setShowPopupScheduleFilters(false))
                                }}
                                cls={'15px'}
                            />
                        }
                    </div>
                </div>

                <div className="px-4 my-2 ">
                    <div className="separator separator-dotted border-gray-300 my-2"></div>
                    <div className="card-body card-scroll h-50 my-2">
                        <h5 className="text-uppercase mb-2">Sort tasks by type units :</h5>
                        <NotFill
                            categories={[
                                { name: 'All', value: 'all', items: [] },
                                { name: 'Sale', value: 'sale', items: [] },
                                { name: 'Rent', value: 'rent', items: [] }
                            ]}
                            selectedCategory={localFilters.sortByTypeUnit}
                            onChange={(sortByTypeUnit) => {
                                setLocalFilters((prev) => ({ ...prev, sortByTypeUnit }))
                            }}
                        />
                    </div>

                    {filterNavigate === 'offers' && (
                        <>
                            <div className="separator separator-dotted border-gray-300 my-2"></div>
                            <div className="card-body card-scroll h-50  my-2">
                                <h5 className="text-uppercase mb-4">Sort offers :</h5>
                                <NotFill
                                    categories={STATUS_PHASES}
                                    selectedCategory={localFilters.byOfferGroups}
                                    onChange={(byOfferGroups) => {
                                        setLocalFilters((prev) => ({ ...prev, byOfferGroups }))
                                    }}
                                />
                            </div>
                        </>
                    )}
                    {filterNavigate === 'viewings' && (
                        <>
                            <div className="separator separator-dotted border-gray-300 my-2"></div>
                            <div className="card-body card-scroll h-50 my-2">
                                <h5 className="text-uppercase mb-4">Sort viewings :</h5>
                                <NotFill
                                    categories={VIEWING_PHASES}
                                    selectedCategory={localFilters.byViewingGroups}
                                    onChange={(byViewingGroups) => {
                                        setLocalFilters((prev) => ({ ...prev, byViewingGroups }))
                                    }}
                                />
                            </div>
                        </>
                    )}
                    {filterNavigate === 'adverts' && (
                        <>
                            <div className="separator separator-dotted border-gray-300 my-2"></div>
                            <div className="card-body card-scroll h-50 my-2">
                                <h5 className="text-uppercase mb-4">Sort advertisements :</h5>
                                <NotFill
                                    categories={ADS_PHASES}
                                    selectedCategory={localFilters.byAddsGroups}
                                    onChange={
                                        (byAddsGroups) => {
                                            setLocalFilters((prev) => ({ ...prev, byAddsGroups }))
                                        }
                                    }
                                />
                            </div>
                        </>
                    )}

                    <>
                        <div className="separator separator-dotted border-gray-300 my-2"></div>
                        <div className="card-body card-scroll h-50 my-2">
                            <h5 className="text-uppercase mb-4">Sort by Unit :</h5>
                            <ScheduleAdminUnitsList
                                units={listUnits}
                                selectedCategory={String(localFilters.unitID)}
                                onChange={(unitID) => {
                                    setLocalFilters((prev) => ({ ...prev, unitID: Number(unitID) || 0 }))
                                }}
                            />
                        </div>


                    </>
                </div>
                <div style={{ height: '70px' }}></div>

                <TopmostFooterPortal>
                    <div className="schedule-filters-footer">
                        <div className="d-flex flex-row w-100 mw-450px h-100 p-4 py-8 mx-auto">
                            {!loading && (
                                <button
                                    onClick={resetFilters}
                                    className={`btn btn-white mt-2 ${userDevice === 'IPhone' ? 'mb-6' : ''} ${loading ? ' disabled' : ''} border-bso2px p-4 fs-4 col-4 me-2 ms-n1 ls-1`}
                                >
                                    <span className="indicator-label">RESET</span>
                                </button>
                            )}

                            {!loading && (
                                <button
                                    className={`btn btn-bso mt-2 ${userDevice === 'IPhone' ? 'mb-6' : ''} ${loading ? ' disabled' : ''} border-bso2px p-4 fs-4 col-8 ls-1`}
                                    onClick={applyFilters}
                                >
                                    {loading ? (
                                        <span className="indicator-progress d-block">
                                            Please wait...
                                            <span className="spinner-border spinner-border-sm align-middle ms-4"></span>
                                        </span>
                                    ) : (
                                        <span className="indicator-label">APPLY</span>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </TopmostFooterPortal>
            </div>
        </div>
    )
}
